module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"AutoloadIT","short_name":"AutoloadIT","start_url":"/","background_color":"#ffffff","theme_color":"#744C9E","display":"standalone","icon":"src/assets/logos/autoloadit.png"},
    },{
      plugin: require('/opt/build/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
